var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Profile__General__Page" }, [
    _vm._m(0),
    _c("div", { staticClass: "Profile__General__Page__Form" }, [
      _c(
        "div",
        {
          staticClass: "Profile__General__Page__Form__Field",
          staticStyle: { display: "flex", gap: "20px" }
        },
        [
          _c(
            "b-field",
            { attrs: { label: "פרופיל מנוהל" } },
            [
              _c(
                "b-switch",
                {
                  on: { input: _vm.onChangeActive },
                  model: {
                    value: _vm.model.IsManaged,
                    callback: function($$v) {
                      _vm.$set(_vm.model, "IsManaged", $$v)
                    },
                    expression: "model.IsManaged"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.model.IsManaged ? "כן" : "לא") + " ")]
              )
            ],
            1
          ),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "הסבה לילית" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeNightRunning },
                      model: {
                        value: _vm.IsOnNightRunning,
                        callback: function($$v) {
                          _vm.IsOnNightRunning = $$v
                        },
                        expression: "IsOnNightRunning"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.IsOnNightRunning ? "כן" : "לא") + " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "אפשר ייבוא מריפורט" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeAllowRePortImport },
                      model: {
                        value: _vm.model.AllowRePortImport,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "AllowRePortImport", $$v)
                        },
                        expression: "model.AllowRePortImport"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.AllowRePortImport ? "כן" : "לא") + " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "אל תציג לשונית חוזים חסרים" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeDontShowMissingContractsTab },
                      model: {
                        value: _vm.model.DontShowMissingContractsTab,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model,
                            "DontShowMissingContractsTab",
                            $$v
                          )
                        },
                        expression: "model.DontShowMissingContractsTab"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.DontShowMissingContractsTab ? "כן" : "לא"
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "חברת ליסינג" } },
                [
                  _c(
                    "b-switch",
                    {
                      on: { input: _vm.onChangeIsLeasingCompany },
                      model: {
                        value: _vm.model.IsLeasingCompany,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "IsLeasingCompany", $$v)
                        },
                        expression: "model.IsLeasingCompany"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.model.IsLeasingCompany ? "כן" : "לא") +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "אפשר שינוי ידני ללקוח" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeAllowManualChangeMenu },
                      model: {
                        value: _vm.model.AllowManualChangeMenu,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "AllowManualChangeMenu", $$v)
                        },
                        expression: "model.AllowManualChangeMenu"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.AllowManualChangeMenu ? "כן" : "לא") +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "שימוש בתאריך תוקף" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeUsesValidDate },
                      model: {
                        value: _vm.model.UsesValidDate,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "UsesValidDate", $$v)
                        },
                        expression: "model.UsesValidDate"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.UsesValidDate ? "כן" : "לא") + " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "הצגת דוח מלא ללקוח" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: {
                        input: _vm.onChangeAllowClientFullReportVisibility
                      },
                      model: {
                        value: _vm.model.AllowClientFullReportVisibility,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model,
                            "AllowClientFullReportVisibility",
                            $$v
                          )
                        },
                        expression: "model.AllowClientFullReportVisibility"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.AllowClientFullReportVisibility ? "כן" : "לא"
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "label",
                        fn: function() {
                          return [
                            _vm._v(" מוקם בריפורט אונליין "),
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: "פרימיום לא ישלח בכל מקרה",
                                  type: "is-dark"
                                }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "information-outline",
                                    size: "is-small"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    450544228
                  )
                },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeIsLocatedInRePortOnline },
                      model: {
                        value: _vm.model.IsLocatedInRePortOnline,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "IsLocatedInRePortOnline", $$v)
                        },
                        expression: "model.IsLocatedInRePortOnline"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.IsLocatedInRePortOnline ? "כן" : "לא") +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAutomationLoading
            ? _c(
                "div",
                [
                  _c("b-loading", {
                    attrs: { "is-full-page": false, "can-cancel": false },
                    model: {
                      value: _vm.isAutomationLoading,
                      callback: function($$v) {
                        _vm.isAutomationLoading = $$v
                      },
                      expression: "isAutomationLoading"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "Profile__General__Page__Form__Field",
          staticStyle: { display: "flex", gap: "20px" }
        },
        [
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "פרופיל מנוהל באוטומציה" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeAutomation },
                      model: {
                        value: _vm.model.IsInAutomation,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "IsInAutomation", $$v)
                        },
                        expression: "model.IsInAutomation"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.model.IsInAutomation ? "כן" : "לא") +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "פרופיל מנוהל במילאון" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeIsInMileon },
                      model: {
                        value: _vm.model.IsInMileon,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "IsInMileon", $$v)
                        },
                        expression: "model.IsInMileon"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.IsInMileon ? "כן" : "לא") + " ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "פרופיל מנוהל במיתר" } },
                [
                  _c(
                    "b-switch",
                    {
                      attrs: { disabled: !_vm.model.IsManaged },
                      on: { input: _vm.onChangeIsInMeitar },
                      model: {
                        value: _vm.model.IsInMeitar,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "IsInMeitar", $$v)
                        },
                        expression: "model.IsInMeitar"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.IsInMeitar ? "כן" : "לא") + " ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "Profile__General__Page__Form__Field" },
        [
          _c(
            "b-field",
            { attrs: { label: "נבדק לאחרונה בתאריך" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    padding: "0 10px",
                    direction: "ltr",
                    "min-width": "144px",
                    border: "1px solid #cbd6e2"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.parseDate(_vm.model.LastCheckDate)))]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    loading: _vm.isUpdatingCheckDate,
                    type: "is-primary"
                  },
                  on: { click: _vm.updateCheckDate }
                },
                [_vm._v("עדכן")]
              )
            ],
            1
          ),
          _vm.isAdmin
            ? _c(
                "b-field",
                { attrs: { label: "תאריך התחלה" } },
                [
                  _c("b-datepicker", {
                    staticClass: "is-rtl",
                    attrs: {
                      disabled: !_vm.model.IsManaged,
                      placeholder: "בחר תאריך",
                      "icon-prev": "chevron-right",
                      "icon-next": "chevron-left",
                      icon: "calendar-today",
                      locale: "en-GB",
                      "day-names": ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
                      "month-names": [
                        "ינואר",
                        "פברואר",
                        "מרץ",
                        "אפריל",
                        "מאי",
                        "יוני",
                        "יולי",
                        "אוגוסט",
                        "ספטמבר",
                        "אוקטובר",
                        "נובמבר",
                        "דצמבר"
                      ],
                      "close-on-click": "",
                      editable: "",
                      "append-to-body": "",
                      dir: "rtl"
                    },
                    on: { input: _vm.onStartDateChange },
                    model: {
                      value: _vm.model.StartDate,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "StartDate", $$v)
                      },
                      expression: "model.StartDate"
                    }
                  }),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        loading: _vm.isSavingStartDate,
                        type: "is-primary"
                      },
                      on: { click: _vm.saveStartDate }
                    },
                    [_vm._v("עדכן")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-field",
            { attrs: { label: "סיסמה למרכז הקנסות" } },
            [
              _c("b-input", {
                attrs: { type: "password", "password-reveal": "" },
                model: {
                  value: _vm.model.FineCenterPassword,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "FineCenterPassword", $$v)
                  },
                  expression: "model.FineCenterPassword"
                }
              }),
              _c(
                "b-button",
                {
                  attrs: { loading: _vm.isSavingPassword, type: "is-primary" },
                  on: { click: _vm.savePassword }
                },
                [_vm._v("עדכן")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isAdmin
        ? _c(
            "div",
            { staticClass: "Profile__General__Page__Form__Field" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "align-items": "center",
                    "margin-bottom": "10px"
                  }
                },
                [
                  _c("h3", [_vm._v("מפתחות API")]),
                  !_vm.isLoadingKeys && _vm.appKeys.length === 0
                    ? _c(
                        "b-button",
                        {
                          attrs: { type: "is-primary", size: "is-small" },
                          on: { click: _vm.openAddKey }
                        },
                        [_vm._v("הוסף מפתח")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "b-table",
                {
                  attrs: {
                    data: _vm.appKeys,
                    loading: _vm.isLoadingKeys,
                    bordered: true,
                    striped: true,
                    narrowed: false,
                    hoverable: false
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "empty",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "has-text-centered" }, [
                              _vm._v("אין מפתחות")
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    40609
                  )
                },
                [
                  _c("b-table-column", {
                    attrs: { label: "שם", field: "Name" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [_vm._v(" " + _vm._s(props.row.Name) + " ")]
                          }
                        }
                      ],
                      null,
                      false,
                      361322874
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { label: "מייל", field: "Email" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [_vm._v(" " + _vm._s(props.row.Email) + " ")]
                          }
                        }
                      ],
                      null,
                      false,
                      2656244529
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { label: "אפליקציות", field: "AppName" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.AppName) + " ")
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      250282363
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { label: "API KEY", field: "ApiKey", centered: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("b-input", {
                                staticStyle: { "max-width": "230px" },
                                attrs: {
                                  readonly: "",
                                  type: "password",
                                  value: props.row.ApiKey,
                                  "password-reveal": ""
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      990778523
                    )
                  }),
                  _c("b-table-column", {
                    attrs: {
                      label: "SECRET KEY",
                      field: "ApiSecret",
                      centered: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("b-input", {
                                staticStyle: { "max-width": "230px" },
                                attrs: {
                                  readonly: "",
                                  type: "password",
                                  value: props.row.ApiSecret,
                                  "password-reveal": ""
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      102953146
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { label: "פעיל", field: "IsActive", centered: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(props.row.IsActive ? "כן" : "לא") +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4043919878
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { label: "", centered: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    gap: "6px",
                                    "justify-content": "center"
                                  }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "is-small",
                                        type: "is-info"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openEditKey(props.row)
                                        }
                                      }
                                    },
                                    [_vm._v("עריכה")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "is-small",
                                        type: "is-danger",
                                        loading:
                                          _vm.deletingKeyId === props.row.UserId
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmDeleteKey(props.row)
                                        }
                                      }
                                    },
                                    [_vm._v("מחיקה")]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2418633692
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "Profile__General__Page__Form__Field" },
        [
          _c("h3", [_vm._v("הגדרות מערכת ניתור")]),
          _c(
            "b-table",
            {
              attrs: {
                data: _vm.model.ProfileTrackingProviders,
                bordered: true,
                striped: true,
                narrowed: false,
                hoverable: false
              }
            },
            [
              _c("b-table-column", {
                attrs: { centered: "", field: "Id", label: "סוג" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "b-select",
                          {
                            attrs: { placeholder: "בחר סוג" },
                            model: {
                              value: props.row.Type.Id,
                              callback: function($$v) {
                                _vm.$set(props.row.Type, "Id", $$v)
                              },
                              expression: "props.row.Type.Id"
                            }
                          },
                          [
                            _c("option", { domProps: { value: 1 } }, [
                              _vm._v("איתוראן")
                            ]),
                            _c("option", { domProps: { value: 2 } }, [
                              _vm._v("פויינטר")
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("b-table-column", {
                attrs: { centered: "", field: "UserName", label: "שם משתמש" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c("b-input", {
                          model: {
                            value: props.row.UserName,
                            callback: function($$v) {
                              _vm.$set(props.row, "UserName", $$v)
                            },
                            expression: "props.row.UserName"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("b-table-column", {
                attrs: {
                  centered: "",
                  field: "Password",
                  label: "סיסמה",
                  width: "200"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c("b-input", {
                          attrs: { type: "password", "password-reveal": "" },
                          model: {
                            value: props.row.Password,
                            callback: function($$v) {
                              _vm.$set(props.row, "Password", $$v)
                            },
                            expression: "props.row.Password"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("b-table-column", {
                attrs: { centered: "", field: "IsActive", label: "פעיל" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "b-switch",
                          {
                            model: {
                              value: props.row.IsActive,
                              callback: function($$v) {
                                _vm.$set(props.row, "IsActive", $$v)
                              },
                              expression: "props.row.IsActive"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(props.row.IsActive ? "כן" : "לא") +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("b-table-column", {
                attrs: { centered: "", field: "IsActive", label: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              loading: _vm.isSavingProfileTracking,
                              type: "is-primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateProfileTracking(props.row)
                              }
                            }
                          },
                          [_vm._v(" עדכן ")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Profile__General__Page__Header" }, [
      _c("h1", [_vm._v("הגדרות פרופיל")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }